import { toast } from "react-toastify";
import FormFieldInput from "components/campos/input";

const AddressFields = ({
  formData, 
  handleChange,
  errors
} : any) => {

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <FormFieldInput
        key={"country"}
        label={"Pais"}
        fieldName={"address.country"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        classe={"md:col-span-2"}
        error={errors['address.country']}
      />

      <FormFieldInput
        key={"state"}
        label={"Estado"}
        fieldName={"address.state"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        error={errors['address.state']}
      />

      <FormFieldInput
        key={"city"}
        label={"Cidade"}
        fieldName={"address.city"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        error={errors['address.city']}
      />

      <FormFieldInput
        key={"postal_code"}
        label={"CEP"}
        fieldName={"address.postal_code"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        error={errors['address.postal_code']}
      />

      <FormFieldInput
        key={"address"}
        label={"Endereço"}
        fieldName={"address.address"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        error={errors['address.address']}
      />

      <FormFieldInput
        key={"number"}
        label={"Número"}
        fieldName={"address.number"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        error={errors['address.number']}
      />

      <FormFieldInput
        key={"district"}
        label={"Bairro"}
        fieldName={"address.district"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        error={errors['address.district']}
      />

      <FormFieldInput
        key={"complement"}
        label={"Complemento"}
        fieldName={"address.complement"}
        type={"text"}
        formData={formData}
        handleChange={handleChange}
        extraProps={{ mdColSpan: 2 }}
        classe={"md:col-span-2"}
        error={errors['address.complement']}
      />
    </div>
  );
};

export default AddressFields;